import { render } from "./MmcRegistrationForm.vue?vue&type=template&id=c581ae8e&scoped=true"
import script from "./MmcRegistrationForm.vue?vue&type=script&lang=js"
export * from "./MmcRegistrationForm.vue?vue&type=script&lang=js"

import "./MmcRegistrationForm.vue?vue&type=style&index=0&id=c581ae8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c581ae8e"]])

export default __exports__